import { render } from "./SessionSetup.vue?vue&type=template&id=70b975a7"
import script from "./SessionSetup.vue?vue&type=script&lang=js"
export * from "./SessionSetup.vue?vue&type=script&lang=js"

import "./SessionSetup.vue?vue&type=style&index=0&id=70b975a7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__